import AssistantTable from './AssistantTable';
export default AssistantTable;
